import { Component, NgZone, OnInit } from '@angular/core';
import { smoothlyMenu } from '../../../app.helpers';
import { SignalRService } from 'app/shared/services/signalr.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { IDtoNotification } from 'app/shared/models/dto-notification.model';
import { IUser } from 'app/shared/models/user.model';
import { SecurityService } from 'app/shared/services/security.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'topnavbar',
  templateUrl: 'topnavbar.template.html'
})
export class TopNavbarComponent implements OnInit {
  private notifications = new Array<IDtoNotification>();
  private notificationCounter: number = 0;
  private errorMessages: any;
  private user: IUser;
  constructor(private signalRService: SignalRService
    , private configurationService: ConfigurationService
    , private ngZone: NgZone
    , private router: Router
    , private route: ActivatedRoute
    , private securityService: SecurityService) {
      this.user = this.securityService.getUserDataStorage();
  }
  ngOnInit() {
    if (this.configurationService.isReady) {
      this.getNotificationsByUserId();
      this.subscribeToEvents();
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.getNotificationsByUserId();
        this.subscribeToEvents();
      });
    }
  }
  toggleNavigation(): void {
    const x = document.getElementsByTagName('BODY')[0];
    x.classList.toggle('mini-navbar');
    smoothlyMenu();
  }
  private subscribeToEvents(): void {
    this.signalRService.messageReceived.subscribe((result: IDtoNotification[]) => {
      this.ngZone.run(() => {
        if (result != null) {
          let filtered  = result.filter(x => x.userId == this.user.userId);
          filtered.forEach(element => {
            this.notifications.push(element)
            console.log(this.notifications);
            this.countNotifications();
          });
        }
      });
    });
  }
  // private showNotification(item: IDtoNotification): void {
  //   item.isActive = false;
  //   this.countNotifications();
  // }
  private countNotifications(): void {
    this.notificationCounter = this.notifications.filter(x => x.isActive == true).length;
  }
  private showNotification(item: IDtoNotification): void {
    item.isActive = false;
    this.countNotifications();
    this.signalRService.updateNotification(item)
      .subscribe(
        (x) => {
          if (x.isCorrect) {
            if (item.moduleName != '/') {
              this.router.navigate([item.moduleName,
                { id: item.usedRecord, action: 'update' }], { relativeTo: this.route });
            }
          } else {
            item.isActive = true;
          }
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
  private getNotificationsByUserId(): void {
    this.signalRService.getNotificationsByUserId(this.user.userId)
      .subscribe(
        (x) => {
          this.notifications = x;
          this.countNotifications();
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
}
